import { Helmet } from "react-helmet-async";
import Card from "../components/ui/Card";

export default function Contact() {
  return (
    <>
      <Helmet>
        <title>Contact | UKPropertyChecks</title>
        <meta
          name="description"
          content="Contact UKPropertyChecks support. Email support@ukpropertychecks.co.uk. We aim to respond within 2 working days."
        />
        <link rel="canonical" href="https://ukpropertychecks.co.uk/contact" />
      </Helmet>

      <main className="bg-white">
        <div className="container-main section-spacing max-w-[720px]">
          <h1>Contact</h1>
          <p className="mt-3 text-base leading-7 text-slate-800">
            We're a small team. Email is the fastest way to reach us.
          </p>

          <div className="mt-8 space-y-6">
            <Card>
              <h2 className="text-lg font-semibold text-slate-950 mb-3">
                Support
              </h2>
              <p className="text-base leading-7 text-slate-800">
                <a
                  href="mailto:support@ukpropertychecks.co.uk"
                  className="text-blue-700 underline hover:text-blue-800"
                >
                  support@ukpropertychecks.co.uk
                </a>
              </p>
              <p className="mt-2 text-sm text-slate-700">
                Use this for questions about a Buyer's Report, a Seller's
                Pack, or anything that's gone wrong with the service. We aim
                to respond within 2 working days.
              </p>
            </Card>

            <Card>
              <h2 className="text-lg font-semibold text-slate-950 mb-3">
                Privacy and data requests
              </h2>
              <p className="text-base leading-7 text-slate-800">
                <a
                  href="mailto:privacy@ukpropertychecks.co.uk"
                  className="text-blue-700 underline hover:text-blue-800"
                >
                  privacy@ukpropertychecks.co.uk
                </a>
              </p>
              <p className="mt-2 text-sm text-slate-700">
                Subject access requests, deletion requests, and questions about
                how we handle your data. We respond within 30 days as required
                by UK GDPR.
              </p>
            </Card>

            <Card>
              <h2 className="text-lg font-semibold text-slate-950 mb-3">
                Legal and Terms
              </h2>
              <p className="text-base leading-7 text-slate-800">
                <a
                  href="mailto:legal@ukpropertychecks.co.uk"
                  className="text-blue-700 underline hover:text-blue-800"
                >
                  legal@ukpropertychecks.co.uk
                </a>
              </p>
              <p className="mt-2 text-sm text-slate-700">
                Questions about our Terms of Service or anything else legal.
              </p>
            </Card>

            <Card variant="subtle">
              <p className="text-sm text-slate-700">
                For urgent legal matters relating to your property transaction,
                consult a solicitor directly. UKPropertyChecks does not provide
                legal advice.
              </p>
            </Card>
          </div>
        </div>
      </main>
    </>
  );
}
